import { Box } from '@mui/material';

import { type TerminProps } from '../../../utils';
import { AccordionWithHeading } from '../AccordionWithHeading';
import { ContentLoading } from '../ContentLoading';
import { HeadingWithTag } from '../HeadingWithTag.tsx';
import { LabelValue } from '../LabelValue';
import { FirstSection } from './FirstSection.tsx';
import { SecondSection } from './SecondSection.tsx';
import { content } from './TerminPlanungsinformationenCard.content';

type TerminPlanungsinformationenCardProps = TerminProps & {
  readonly thema: NonNullable<TerminProps['thema']>;
  readonly isPlanung?: boolean;
};

export const TerminPlanungsinformationenCard = ({
  thema,
  bordered,
  isPlanung = false,
  withoutAccordion,
}: TerminPlanungsinformationenCardProps) => {
  if (!thema.planungsinformation) {
    return (
      <AccordionWithHeading heading={content.heading}>
        <ContentLoading />
      </AccordionWithHeading>
    );
  }

  const { planungsinformation } = thema;

  const { istTerminreihe } = planungsinformation;

  return (
    <AccordionWithHeading
      heading={<HeadingWithTag heading={content.heading} tag="cserv" />}
      bordered={bordered}
      grow={true}
      noAccordion={withoutAccordion}
    >
      <Box display="grid" gap={3}>
        <FirstSection
          planungsinformation={planungsinformation}
          planungsformat={thema.planungsformat}
          isPlanung={isPlanung}
        />
        <SecondSection
          planungsinformation={planungsinformation}
          isOnline={thema.isOnline}
          planungsformat={thema.planungsformat}
          module={thema.module}
        />
        {istTerminreihe && (
          <LabelValue key={content.fields.terminreihe} label={content.fields.terminreihe} value={content.ja} />
        )}
      </Box>
    </AccordionWithHeading>
  );
};
